import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative h-screen min-h-[700px] w-full overflow-hidden flex items-center justify-center" data-id="element-205">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-206">
        <img src="https://images.unsplash.com/photo-1528319725582-ddc096101511?q=80&w=2070&auto=format&fit=crop" alt="Peaceful meditation garden" className="w-full h-full object-cover" data-id="element-207" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-[#FAF7F2]" data-id="element-208" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-210">
          <span className="inline-block py-1 px-3 rounded-full bg-white/20 backdrop-blur-sm text-white border border-white/30 text-sm tracking-widest uppercase mb-6" data-id="element-211">
            Welcome to Inner Peace
          </span>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white font-light mb-6 leading-tight" data-id="element-212">
            Supradhyan <br data-id="element-213" />
            <span className="italic text-[#FAF7F2]" data-id="element-214">Enlightenment Center</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 font-light leading-relaxed" data-id="element-215">
            Discover the path to tranquility, self-realization, and harmony
            through ancient meditation practices guided by wisdom.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-216">
            <Link to="/start-journey" className="bg-[#FAF7F2] text-[#2C3E50] hover:bg-white px-8 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 shadow-lg inline-block" data-id="element-217">
              Start Your Journey
            </Link>
            <Link to="/start-journey" className="bg-transparent border border-white text-white hover:bg-white/10 px-8 py-3 rounded-full font-medium transition-all duration-300 backdrop-blur-sm inline-block" data-id="element-218">
              Watch Video
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/70" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-219">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-1" data-id="element-220">
          <div className="w-1 h-2 bg-white rounded-full" data-id="element-221" />
        </div>
      </motion.div>
    </section>;
}